// extracted by mini-css-extract-plugin
export default {"bg-image-vertical":"Login_bg-image-vertical__QofZs","h-custom-2":"Login_h-custom-2__WsJpF"};